export default function Home(props) {

    const {user, displayName} = props;

    return (
        <>
            Bonjour {user.displayName ? user.displayName : displayName}, bienvenue sur l'espace soignants !
        </>
    );
}